import { render, staticRenderFns } from "./WorkFromHome.vue?vue&type=template&id=f4160d9c&scoped=true"
import script from "./WorkFromHome.vue?vue&type=script&lang=js"
export * from "./WorkFromHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4160d9c",
  null
  
)

export default component.exports